export default "__VITE_ASSET__B0lMX9p1__"